import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { setErrorMsg, setPage } from "../../../../stores/VacuumStore/VacuumStore";
import { PAGES } from "../../../../stores/VacuumStore/VacumStore.types";

const InactivityTimer = ({ timeout = 30000 }) => {
  const navigate = useNavigate();
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  // Resetar timer
  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
      
    timerRef.current = setTimeout(() => {
      handleTimeout()
    }, timeout);
  };

  const handleTimeout = () => {
    const msg = "Tempo máximo sem interação atingido.";
    console.warn(msg);
    setErrorMsg(msg);
    setPage(PAGES.VACUUM_PAYMENT_ERROR);
  }

  useEffect(() => {
    // Eventos que contam como atividade
    const events = ["mousemove", "pointerdown", "mousedown", "keydown", "touchstart"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    // Limpeza
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [timeout, navigate]);

  return null;
};

export default InactivityTimer;
